import {call, put} from "redux-saga/effects";
import {fetchShipmentData} from "../api/shipmentDataApi";
import {receiveShipmentDetailsData} from "../actions/shipmentDetailsDataActions";

export default function* getShipmentDetailsData(action) {
    try {
        const data = []
        for (let item of action.payload) {
            data.push(yield call(fetchShipmentData, item));
        }
        if (data.length > 0) {
            yield put(receiveShipmentDetailsData(data[0]));
        }
        //ToDO Need to figure out how to handle if a tracking Id was not found
    } catch (e) {
        console.log(e);
    }
}



// WEBPACK FOOTER //
// ./src/sagas/shipmentDetailsSaga.js